import './rxjs-extensions';

import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { GenericdatasetService } from '../../services/genericdataset/genericdataset.service';
//import { SharedAppModule } from '../../shared.module';

import { StepsComponent } from './steps.component';
import { StepsRoutingModule } from './steps.routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    StepsRoutingModule,
    ReactiveFormsModule,
    //SharedAppModule
  ],
  exports: [
    StepsComponent
  ],
  declarations: [
    StepsComponent
  ],
  providers: [
    GenericdatasetService
  ],
})
export class StepsModule { }
